"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeviceSizes = void 0;
var React = __importStar(require("react"));
var context_1 = require("../context");
/**
 * Utility hook to interrogate the current breakpoint in terms of commonly used screen size names.
 *
 * @remarks
 * These are simply based on pixel sizes and should not be construed to imply functionality (touch, etc.);
 *
 * @example
 * // To only render an element on mobile:
 * const { isMobileSized } = useDeviceSize();
 * return isMobileSized && element;
 */
var useDeviceSizes = function () {
    var _a = React.useContext(context_1.WindowSizeContext), _b = _a.isMobileSized, isMobileSized = _b === void 0 ? false : _b, _c = _a.isTabletSized, isTabletSized = _c === void 0 ? false : _c, _d = _a.isDesktopSized, isDesktopSized = _d === void 0 ? false : _d;
    return { isDesktopSized: isDesktopSized, isMobileSized: isMobileSized, isTabletSized: isTabletSized };
};
exports.useDeviceSizes = useDeviceSizes;
exports.default = exports.useDeviceSizes;
